///////////////////////////////////////////////////////
// This is a generated file
// DO NOT EDIT - Use generate-assets.js
///////////////////////////////////////////////////////
import { AssetByIconName, IconName } from './Icon.types';
import Activity from './assets/activity.svg';
import AddSquare from './assets/add-square.svg';
import Add from './assets/add.svg';
import Arrow2Down from './assets/arrow-2-down.svg';
import Arrow2Left from './assets/arrow-2-left.svg';
import Arrow2Right from './assets/arrow-2-right.svg';
import Arrow2Up from './assets/arrow-2-up.svg';
import Arrow2Upright from './assets/arrow-2-upright.svg';
import ArrowDoubleLeft from './assets/arrow-double-left.svg';
import ArrowDoubleRight from './assets/arrow-double-right.svg';
import ArrowDown from './assets/arrow-down.svg';
import ArrowLeft from './assets/arrow-left.svg';
import ArrowRight from './assets/arrow-right.svg';
import ArrowUp from './assets/arrow-up.svg';
import Ban from './assets/ban.svg';
import BankToken from './assets/bank-token.svg';
import Bank from './assets/bank.svg';
import Bold from './assets/bold.svg';
import Book from './assets/book.svg';
import Bookmark from './assets/bookmark.svg';
import Bridge from './assets/bridge.svg';
import Calculator from './assets/calculator.svg';
import CardPos from './assets/card-pos.svg';
import CardToken from './assets/card-token.svg';
import Card from './assets/card.svg';
import Category from './assets/category.svg';
import Chart2 from './assets/chart-2.svg';
import Chart from './assets/chart.svg';
import CheckBold from './assets/check-bold.svg';
import CheckBoxOff from './assets/check-box-off.svg';
import CheckBoxOn from './assets/check-box-on.svg';
import CheckCircleOff from './assets/check-circle-off.svg';
import Check from './assets/check.svg';
import CircleX from './assets/circle-x.svg';
import Clock from './assets/clock.svg';
import Close from './assets/close.svg';
import CodeCircle from './assets/code-circle.svg';
import Coin from './assets/coin.svg';
import Confirmation from './assets/confirmation.svg';
import Connect from './assets/connect.svg';
import CopySuccess from './assets/copy-success.svg';
import Copy from './assets/copy.svg';
import Customize from './assets/customize.svg';
import Danger from './assets/danger.svg';
import Dark from './assets/dark.svg';
import Data from './assets/data.svg';
import Diagram from './assets/diagram.svg';
import DocumentCode from './assets/document-code.svg';
import Download from './assets/download.svg';
import Edit from './assets/edit.svg';
import Eraser from './assets/eraser.svg';
import Ethereum from './assets/ethereum.svg';
import Expand from './assets/expand.svg';
import Explore from './assets/explore.svg';
import Export from './assets/export.svg';
import EyeSlash from './assets/eye-slash.svg';
import Eye from './assets/eye.svg';
import File from './assets/file.svg';
import Filter from './assets/filter.svg';
import Flag from './assets/flag.svg';
import FlashSlash from './assets/flash-slash.svg';
import Flash from './assets/flash.svg';
import Flask from './assets/flask.svg';
import Fox from './assets/fox.svg';
import FullCircle from './assets/full-circle.svg';
import Gas from './assets/gas.svg';
import GlobalSearch from './assets/global-search.svg';
import Global from './assets/global.svg';
import Graph from './assets/graph.svg';
import Hardware from './assets/hardware.svg';
import Heart from './assets/heart.svg';
import Hierarchy from './assets/hierarchy.svg';
import Home from './assets/home.svg';
import Import from './assets/import.svg';
import Info from './assets/info.svg';
import Key from './assets/key.svg';
import Light from './assets/light.svg';
import Link2 from './assets/link-2.svg';
import Link from './assets/link.svg';
import Loading from './assets/loading.svg';
import LockCircle from './assets/lock-circle.svg';
import LockSlash from './assets/lock-slash.svg';
import Lock from './assets/lock.svg';
import Login from './assets/login.svg';
import Logout from './assets/logout.svg';
import Menu from './assets/menu.svg';
import MessageQuestion from './assets/message-question.svg';
import Messages from './assets/messages.svg';
import MinusBold from './assets/minus-bold.svg';
import MinusSquare from './assets/minus-square.svg';
import Minus from './assets/minus.svg';
import Mobile from './assets/mobile.svg';
import Money from './assets/money.svg';
import Monitor from './assets/monitor.svg';
import MoreHorizontal from './assets/more-horizontal.svg';
import MoreVertical from './assets/more-vertical.svg';
import NotificationCircle from './assets/notification-circle.svg';
import Notification from './assets/notification.svg';
import PasswordCheck from './assets/password-check.svg';
import People from './assets/people.svg';
import Plug from './assets/plug.svg';
import ProgrammingArrows from './assets/programming-arrows.svg';
import QrCode from './assets/qr-code.svg';
import Question from './assets/question.svg';
import Received from './assets/received.svg';
import Refresh from './assets/refresh.svg';
import Save from './assets/save.svg';
import ScanBarcode from './assets/scan-barcode.svg';
import ScanFocus from './assets/scan-focus.svg';
import Scan from './assets/scan.svg';
import Scroll from './assets/scroll.svg';
import Search from './assets/search.svg';
import SecurityCard from './assets/security-card.svg';
import SecurityCross from './assets/security-cross.svg';
import SecurityKey from './assets/security-key.svg';
import SecuritySearch from './assets/security-search.svg';
import SecuritySlash from './assets/security-slash.svg';
import SecurityTick from './assets/security-tick.svg';
import SecurityTime from './assets/security-time.svg';
import SecurityUser from './assets/security-user.svg';
import Security from './assets/security.svg';
import Send1 from './assets/send-1.svg';
import Send2 from './assets/send-2.svg';
import Setting from './assets/setting.svg';
import Share from './assets/share.svg';
import Slash from './assets/slash.svg';
import SnapsMobile from './assets/snaps-mobile.svg';
import SnapsPlus from './assets/snaps-plus.svg';
import Snaps from './assets/snaps.svg';
import Speedometer from './assets/speedometer.svg';
import Square from './assets/square.svg';
import Star from './assets/star.svg';
import Student from './assets/student.svg';
import SwapHorizontal from './assets/swap-horizontal.svg';
import SwapVertival from './assets/swap-vertival.svg';
import Tag from './assets/tag.svg';
import Tilde from './assets/tilde.svg';
import Timer from './assets/timer.svg';
import Trash from './assets/trash.svg';
import TrendDown from './assets/trend-down.svg';
import TrendUp from './assets/trend-up.svg';
import Twitter from './assets/twitter.svg';
import Upload from './assets/upload.svg';
import Usb from './assets/usb.svg';
import UserAdd from './assets/user-add.svg';
import UserCheck from './assets/user-check.svg';
import UserCircleAdd from './assets/user-circle-add.svg';
import UserCircle from './assets/user-circle.svg';
import UserMinus from './assets/user-minus.svg';
import UserRemove from './assets/user-remove.svg';
import UserSearch from './assets/user-search.svg';
import UserTick from './assets/user-tick.svg';
import User from './assets/user.svg';
import WalletCard from './assets/wallet-card.svg';
import WalletMoney from './assets/wallet-money.svg';
import Wallet from './assets/wallet.svg';
import Warning from './assets/warning.svg';
import Wifi from './assets/wifi.svg';

/**
 * Asset stored by icon name
 */
export const assetByIconName: AssetByIconName = {
  [IconName.Activity]: Activity,
  [IconName.AddSquare]: AddSquare,
  [IconName.Add]: Add,
  [IconName.Arrow2Down]: Arrow2Down,
  [IconName.Arrow2Left]: Arrow2Left,
  [IconName.Arrow2Right]: Arrow2Right,
  [IconName.Arrow2Up]: Arrow2Up,
  [IconName.Arrow2Upright]: Arrow2Upright,
  [IconName.ArrowDoubleLeft]: ArrowDoubleLeft,
  [IconName.ArrowDoubleRight]: ArrowDoubleRight,
  [IconName.ArrowDown]: ArrowDown,
  [IconName.ArrowLeft]: ArrowLeft,
  [IconName.ArrowRight]: ArrowRight,
  [IconName.ArrowUp]: ArrowUp,
  [IconName.Ban]: Ban,
  [IconName.BankToken]: BankToken,
  [IconName.Bank]: Bank,
  [IconName.Bold]: Bold,
  [IconName.Book]: Book,
  [IconName.Bookmark]: Bookmark,
  [IconName.Bridge]: Bridge,
  [IconName.Calculator]: Calculator,
  [IconName.CardPos]: CardPos,
  [IconName.CardToken]: CardToken,
  [IconName.Card]: Card,
  [IconName.Category]: Category,
  [IconName.Chart2]: Chart2,
  [IconName.Chart]: Chart,
  [IconName.CheckBold]: CheckBold,
  [IconName.CheckBoxOff]: CheckBoxOff,
  [IconName.CheckBoxOn]: CheckBoxOn,
  [IconName.CheckCircleOff]: CheckCircleOff,
  [IconName.Check]: Check,
  [IconName.CircleX]: CircleX,
  [IconName.Clock]: Clock,
  [IconName.Close]: Close,
  [IconName.CodeCircle]: CodeCircle,
  [IconName.Coin]: Coin,
  [IconName.Confirmation]: Confirmation,
  [IconName.Connect]: Connect,
  [IconName.CopySuccess]: CopySuccess,
  [IconName.Copy]: Copy,
  [IconName.Customize]: Customize,
  [IconName.Danger]: Danger,
  [IconName.Dark]: Dark,
  [IconName.Data]: Data,
  [IconName.Diagram]: Diagram,
  [IconName.DocumentCode]: DocumentCode,
  [IconName.Download]: Download,
  [IconName.Edit]: Edit,
  [IconName.Eraser]: Eraser,
  [IconName.Ethereum]: Ethereum,
  [IconName.Expand]: Expand,
  [IconName.Explore]: Explore,
  [IconName.Export]: Export,
  [IconName.EyeSlash]: EyeSlash,
  [IconName.Eye]: Eye,
  [IconName.File]: File,
  [IconName.Filter]: Filter,
  [IconName.Flag]: Flag,
  [IconName.FlashSlash]: FlashSlash,
  [IconName.Flash]: Flash,
  [IconName.Flask]: Flask,
  [IconName.Fox]: Fox,
  [IconName.FullCircle]: FullCircle,
  [IconName.Gas]: Gas,
  [IconName.GlobalSearch]: GlobalSearch,
  [IconName.Global]: Global,
  [IconName.Graph]: Graph,
  [IconName.Hardware]: Hardware,
  [IconName.Heart]: Heart,
  [IconName.Hierarchy]: Hierarchy,
  [IconName.Home]: Home,
  [IconName.Import]: Import,
  [IconName.Info]: Info,
  [IconName.Key]: Key,
  [IconName.Light]: Light,
  [IconName.Link2]: Link2,
  [IconName.Link]: Link,
  [IconName.Loading]: Loading,
  [IconName.LockCircle]: LockCircle,
  [IconName.LockSlash]: LockSlash,
  [IconName.Lock]: Lock,
  [IconName.Login]: Login,
  [IconName.Logout]: Logout,
  [IconName.Menu]: Menu,
  [IconName.MessageQuestion]: MessageQuestion,
  [IconName.Messages]: Messages,
  [IconName.MinusBold]: MinusBold,
  [IconName.MinusSquare]: MinusSquare,
  [IconName.Minus]: Minus,
  [IconName.Mobile]: Mobile,
  [IconName.Money]: Money,
  [IconName.Monitor]: Monitor,
  [IconName.MoreHorizontal]: MoreHorizontal,
  [IconName.MoreVertical]: MoreVertical,
  [IconName.NotificationCircle]: NotificationCircle,
  [IconName.Notification]: Notification,
  [IconName.PasswordCheck]: PasswordCheck,
  [IconName.People]: People,
  [IconName.Plug]: Plug,
  [IconName.ProgrammingArrows]: ProgrammingArrows,
  [IconName.QrCode]: QrCode,
  [IconName.Question]: Question,
  [IconName.Received]: Received,
  [IconName.Refresh]: Refresh,
  [IconName.Save]: Save,
  [IconName.ScanBarcode]: ScanBarcode,
  [IconName.ScanFocus]: ScanFocus,
  [IconName.Scan]: Scan,
  [IconName.Scroll]: Scroll,
  [IconName.Search]: Search,
  [IconName.SecurityCard]: SecurityCard,
  [IconName.SecurityCross]: SecurityCross,
  [IconName.SecurityKey]: SecurityKey,
  [IconName.SecuritySearch]: SecuritySearch,
  [IconName.SecuritySlash]: SecuritySlash,
  [IconName.SecurityTick]: SecurityTick,
  [IconName.SecurityTime]: SecurityTime,
  [IconName.SecurityUser]: SecurityUser,
  [IconName.Security]: Security,
  [IconName.Send1]: Send1,
  [IconName.Send2]: Send2,
  [IconName.Setting]: Setting,
  [IconName.Share]: Share,
  [IconName.Slash]: Slash,
  [IconName.SnapsMobile]: SnapsMobile,
  [IconName.SnapsPlus]: SnapsPlus,
  [IconName.Snaps]: Snaps,
  [IconName.Speedometer]: Speedometer,
  [IconName.Square]: Square,
  [IconName.Star]: Star,
  [IconName.Student]: Student,
  [IconName.SwapHorizontal]: SwapHorizontal,
  [IconName.SwapVertival]: SwapVertival,
  [IconName.Tag]: Tag,
  [IconName.Tilde]: Tilde,
  [IconName.Timer]: Timer,
  [IconName.Trash]: Trash,
  [IconName.TrendDown]: TrendDown,
  [IconName.TrendUp]: TrendUp,
  [IconName.Twitter]: Twitter,
  [IconName.Upload]: Upload,
  [IconName.Usb]: Usb,
  [IconName.UserAdd]: UserAdd,
  [IconName.UserCheck]: UserCheck,
  [IconName.UserCircleAdd]: UserCircleAdd,
  [IconName.UserCircle]: UserCircle,
  [IconName.UserMinus]: UserMinus,
  [IconName.UserRemove]: UserRemove,
  [IconName.UserSearch]: UserSearch,
  [IconName.UserTick]: UserTick,
  [IconName.User]: User,
  [IconName.WalletCard]: WalletCard,
  [IconName.WalletMoney]: WalletMoney,
  [IconName.Wallet]: Wallet,
  [IconName.Warning]: Warning,
  [IconName.Wifi]: Wifi,
};
